import { BlockControls, BlockVerticalAlignmentToolbar } from '@wordpress/block-editor';
import { __ } from '@wordpress/i18n';
import {CopyPasteStyles} from '@vayu-blocks';

const Controls = ({ attributes, setAttributes }) => {
	const changeVerticalAlign = (value) => {
		setAttributes({
			verticalAlign: attributes.verticalAlign === value ? 'unset' : value,
		});
	};

	const getVerticalAlignValue = () => {
		if (attributes.verticalAlign === 'flex-start') return 'top';
		if (attributes.verticalAlign === 'flex-end') return 'bottom';
		return attributes.verticalAlign;
	};

	return (
		<BlockControls>
			{/* <BlockVerticalAlignmentToolbar onChange={changeVerticalAlign} value={getVerticalAlignValue()} /> */}
			<CopyPasteStyles attributes={attributes} setAttributes={setAttributes} />
		</BlockControls>
	);
};

export default Controls;